class ProductBenefits extends HTMLElement {
  connectedCallback() {
    this.initSlider()
  }

  getBulletString(index) {
    const pageStrings = this.getAttribute('bullet-items').split(',')
    return pageStrings[index]
  }

  initSlider() {
    const swiperEl = this.querySelector(`swiper-container`)

    const swiperParams = {
      autoHeight: true,
      centeredSlides: false,
      slidesPerView: 1,
      spaceBetween: 15,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">${this.getBulletString(index)}</span>`
        },
      },
    }

    Object.assign(swiperEl, swiperParams)
    swiperEl.initialize()
  }
}

window.customElements.define('product-benefits', ProductBenefits)
